import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    path:'/',
    redirect:'/login'
},{
    path: '/login', //登录
    name: 'login',
    component: () =>
        import ('../views/login/login.vue')
    },
    {
        path: '/ForgetPassword', //忘记密码
        name: 'ForgetPassword',
        component: () =>
            import ('../views/login/ForgetPassword.vue')
    },
    {
        path: '/index', //主页
        name: 'index',
        component: () =>
            import ('../views/index/index.vue')
    },
 ]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router